import apiClient from "@/app/api/client";
import type { LeadDetail, LeadExportJob, LeadMapPoint } from "../types";

interface SingleResponse<T> {
	success: true;
	data: T;
}

export const leadsService = {
	async detail(id: string): Promise<LeadDetail> {
		const response = await apiClient.get<SingleResponse<LeadDetail>>(`/leads/${id}`);
		return response.data.data;
	},

	async map(params: Record<string, unknown>): Promise<{
		points: LeadMapPoint[];
		limit: number;
		truncated: boolean;
	}> {
		const response = await apiClient.get<
			SingleResponse<{ points: LeadMapPoint[]; limit: number; truncated: boolean }>
		>("/leads/map", { params });
		return response.data.data;
	},

	async requestExport(body: Record<string, unknown>): Promise<LeadExportJob> {
		const response = await apiClient.post<SingleResponse<LeadExportJob>>("/leads/export", body);
		return response.data.data;
	},

	async exportStatus(id: string): Promise<LeadExportJob> {
		const response = await apiClient.get<SingleResponse<LeadExportJob>>(`/leads/exports/${id}`);
		return response.data.data;
	},

	/**
	 * ⚠️ **Yuklab olish `apiClient` ORQALI, oddiy havola bilan EMAS.**
	 * `GET /leads/exports/{id}/download` `authMiddleware` bilan
	 * himoyalangan va access token faqat JS xotirasida (CLAUDE.md auth
	 * modeli) — `<a href>` unga Bearer sarlavhasini qo'sha olmaydi va
	 * 401 qaytarardi.
	 */
	async download(id: string): Promise<Blob> {
		const response = await apiClient.get<Blob>(`/leads/exports/${id}/download`, {
			responseType: "blob",
		});
		return response.data;
	},
};
